module.exports = __webpack_public_path__ + "img/矩形 79@1x.56cb5de8.png";